<template>
  <div class="Game_sub-btns">
    <span class="sub-btn-top" @click="send('SHOW_RULE')">
      <em>规则</em>
    </span>
    <span class="sub-btn-bottom" v-if="state.context.userAgent.weixin || state.context.userAgent.QQ" @click="send('GO_STORE', { url: state.context.gameConfig.service_zone })">
      <em>商城</em>
    </span>
    <span class="sub-btn-bottom" @click="showShareDailog">
      <em>分享</em>
    </span>
  </div>
</template>
<script>
import * as userBusiness from "../business/user"

export default {
  props: ["state", "send"],

  setup(props, { root }) {
    const showShareDailog = () => {
      root.$store.commit("SET_IS_SHOW_SHARE", true)

      if (props.state.context?.report?.CLICK?.SHARE) {
        userBusiness.reportUserAction({
          loginState: props.state.context?.loginState,
          offerId: props.state.context?.gameConfig?.offerId,
          pf: props.state.context?.pf,
          iformat: props.state.context?.report?.CLICK?.SHARE
        })
      }
    }

    return {
      showShareDailog
    }
  }
}
</script>
